export const hasAnyKey = (obj) => {
  return obj && Object.keys(obj).length > 0;
};
